// extracted by mini-css-extract-plugin
module.exports = {"linkDefault":"link-color_linkDefault__xgSfW","styles2023":"link-color_styles2023__x6ntx","styles2024":"link-color_styles2024__s1yEi","linkWhite":"link-color_linkWhite__CV0KM"};